import React, { Component } from 'react';
import actions from '../store/actions';
import SimpleReactValidator from 'simple-react-validator';
import { isNumeric } from '../../../utils/helpres';
import { connect } from 'react-redux';
import InputField from '../../../components/inputField';
import moment from 'moment';
import { codeBureauCNAM, ModePaiement } from '../../../utils/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const mapStateToProps = (state, ownProps) => {
  const { depense } = ownProps;
  let label;
  let payment_mode;
  let payment_date;
  let note;
  let id;
  let orde_virement;
  let price;
  let date_cheque;
  let num_cheque;
  if (depense) {
    id = depense.id;
    label = depense.label;
    payment_mode = depense.payment_mode;
    date_cheque = depense.date_cheque;
    payment_date = depense.payment_date;
    note = depense.note || '';
    orde_virement = depense.orde_virement;
    num_cheque = depense.num_cheque;
    price = depense.price;
  }
  return {
    isLoadingDepenseById: state.DepenseReducer.isLoadingDepenseById,
    depense: state.DepenseReducer.depense,
    actionDepense: state.DepenseReducer.actionDepense,
    isLoadingActionDepense: state.DepenseReducer.isLoadingActionDepense,
    sandwich_menu_btn: state.AppReducer.sandwich_menu_btn,
    user: state.AppReducer.user,
    params: state.DepenseReducer.params,
    initialValues: {
      ...depense,
      id,
      label,
      payment_mode,
      payment_date,
      note: note || '',
      date_cheque: date_cheque || '',
      num_cheque,
      price,
      orde_virement,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDepenseById: (id) => dispatch(actions.getDepenseById(id)),
  submitDepenseForm: async (values, params) => {
    await dispatch(actions.submitDepenseForm(values, params));
    await dispatch(actions.getAllDepenses(params));
  },
});

class FormRecette extends Component {
  constructor(props) {
    super(props);
    //props.getDepenseById(null);
    this.state = {
      initialValues: {
        ...props.initialValues,
        alert: false,
      },
      activeTab: '1',
      isOpenToggleDiplome: false,
      isOpenToggleFormation: false,
      errorDate: false,
      hasError: false,
      errorDateBill: false,
    };
    this.handleInitialValues = this.handleInitialValues.bind(this);
  }
  handleInitialValues() {
    this.setState({
      initialValues: {
        note: '',
        payment_date: '',
        payment_mode: '',
        label: '',
        orde_virement: '',
        price: '',
        num_cheque: '',
        date_cheque: '',
      },
      hasError: false,
      errorDateBill: false,
    });
  }
  submitForm(initialValues) {
    if (
      !initialValues.label ||
      !initialValues.payment_date ||
      !initialValues.payment_mode
    ) {
      this.setState({
        ...initialValues,
        hasError: true,
      });
    } else {
      this.props.submitDepenseForm(initialValues, this.props.params);
      this.props.changeActiveItemSideBarRDV(this.props.activeItemSideBarRDV);
      this.props.getDepenseById(null);
    }
  }

  render() {
    const { isLoadingActionRecette } = this.props;
    const { initialValues, hasError } = this.state;
    return (
      <form>
        <div className="form-row">
          <InputField
            width="46%"
            className="form-group"
            type="text"
            placeholder="Motif"
            label="Motif"
            hasError={hasError}
            //  validInput="string"
            value={initialValues.label}
            name="label"
            icon={<i className="fas fa-pen"></i>}
            onChange={(e) => {
              this.setState({
                initialValues: {
                  ...initialValues,
                  label: e.target.value,
                },
              });
            }}
          />
          <InputField
            width="46%"
            className="form-group"
            type="date"
            placeholder="Date de paiment"
            label="Date de paiment"
            //errorDate={initialValues.payment_date}
            hasError={hasError}
            value={initialValues.payment_date}
            name="payment_date"
            icon=""
            onChange={(e) => {
              this.setState({
                initialValues: {
                  ...initialValues,
                  payment_date: e.target.value,
                },
              });
            }}
          />
        </div>
        <div className="form-row">
          <div
            style={{
              width: '46%',
            }}
            className={
              hasError && !initialValues.payment_mode ? 'form-group type3' : 'form-group'
            }
          >
            <label htmlFor="">Mode de paiement</label>
            <div className="input_and_icon">
              <select
                value={initialValues.payment_mode}
                style={{
                  marginBottom: '1%',
                  height: 'fit-content',
                  alignSelf: 'end',
                  width: '100%',
                  border: 0,
                }}
                onChange={(e) => {
                  this.setState({
                    initialValues: {
                      ...initialValues,
                      payment_mode: e.target.value,
                    },
                  });
                }}
              >
                <option value="">Choisissez</option>
                <option value="Espèce">Espèce</option>
                <option value="Chèque">Chèque</option>
                <option value="Virement">Virement</option>
              </select>
            </div>
          </div>
          <InputField
            width="46%"
            className="form-group"
            type="text"
            placeholder="12.00"
            label="Prix"
            hasError={hasError}
            value={initialValues.price}
            name="price"
            icon={<i className="fas fa-pen"></i>}
            validInput="integer"
            onChange={(e) => {
              this.setState({
                initialValues: {
                  ...initialValues,
                  price: e.target.value,
                },
              });
            }}
          />
        </div>
        {initialValues.payment_mode === 'Chèque' ? (
          <div className="form-row">
            <InputField
              width="46%"
              className="form-group"
              type="text"
              placeholder="Numéro du chèque"
              label="Numéro du chèque"
              hasError={hasError}
              value={initialValues.num_cheque}
              name="num_cheque"
              icon={<i className="fas fa-pen"></i>}
              validInput="string"
              onChange={(e) => {
                this.setState({
                  initialValues: {
                    ...initialValues,
                    num_cheque: e.target.value,
                  },
                });
              }}
            />
            <InputField
              width="50%"
              className="form-group"
              type="date"
              placeholder="Date d'échéance"
              label="Date d'échéance"
              hasError={hasError}
              value={initialValues.date_cheque}
              name="date_cheque"
              icon={<i className="fas fa-pen"></i>}
              validInput="string"
              onChange={(e) => {
                this.setState({
                  initialValues: {
                    ...initialValues,
                    date_cheque: e.target.value,
                  },
                });
              }}
            />
          </div>
        ) : (
          ''
        )}
        {initialValues.payment_mode === 'Virement' ? (
          <div className="form-row">
            <InputField
              width="50%"
              className="form-group"
              type="text"
              placeholder="Ordre de virement"
              label="Ordre de virement"
              hasError={hasError}
              value={initialValues.orde_virement}
              name="orde_virement"
              icon={<i className="fas fa-pen"></i>}
              validInput="string"
              onChange={(e) => {
                this.setState({
                  initialValues: {
                    ...initialValues,
                    orde_virement: e.target.value,
                  },
                });
              }}
            />
          </div>
        ) : (
          ''
        )}

        <div
          className="form-4row"
          style={{
            width: '98%',
          }}
        >
          <div
            style={{ width: '100%' }}
            className="col-md-12 mb-3 commentaire add_dispo_item commentaire"
          >
            <span id="date_de_debut_title">
              Note ({(initialValues.note && initialValues.note.length) || 0}/255)
            </span>
            <div className="date_de_debut_icon input_and_icon">
              <textarea
                maxLength="255"
                rows={5}
                style={{ width: '100%' }}
                onChange={(e) => {
                  this.setState({
                    initialValues: {
                      ...initialValues,
                      note: e.target.value,
                    },
                  });
                }}
                value={initialValues.note}
                name="message"
                className="sub_text_container"
                id="date_de_debut_text"
                placeholder="Note"
              ></textarea>
            </div>
            <span></span>
          </div>
        </div>
        <div className="footer_buttons">
          {/*<button
            type="button"
            onClick={() => {
              this.handleInitialValues();
            }}
            className="footer_btn"
            id="cancel"
          >
            Annuler
          </button>*/}
          <button
            style={{ marginRight: '5%' }}
            onClick={() => {
              this.submitForm(initialValues);
            }}
            type="button"
            className="footer_btn"
            id="update"
          >
            {isLoadingActionRecette ? (
              <CircularProgress
                style={{
                  marginLeft: '4%',
                  width: '25px',
                  height: '25px',
                  color: 'white',
                  marginTop: '5%',
                }}
              />
            ) : (
              'Valider'
            )}
          </button>
        </div>
      </form>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FormRecette);
